<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="1000"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Divider orientation="left" class="text-primary">选择销售员</Divider>
                    <Col span="12">
                        <FormItem label="转出业务员" prop="from_id">
                            <Select v-model="Forms.from_id" @on-change="getCustomerList" clearable filterable  placeholder="业务员">
                                <Option v-for="(item,index) in salerList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="转入业务员" prop="to_id">
                            <Select v-model="Forms.to_id" clearable filterable  placeholder="业务员">
                                <Option v-for="(item,index) in salerList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Divider orientation="left" class="text-primary">选择客户</Divider>
                    <Col span="24">
                        <Table row-key="id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" @on-selection-change="tableCheckAll" :data="customerList" no-data-text="暂无数据记录">
                        </Table>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认转移</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getCustomerConfig, getCustomerSelectList, saveCustomerTransfer} from "@/apis/customer";

export default {
    name: 'CustomerTransfer',
    components: {
    },
    data () {
        return {
            title : '转移客户',
            isBox : false,
            salerList: [],
            customerList: [],
            selectCount: 0,

            Forms: {
                from_id: '',
                to_id: '',
                customer_id: []
            },
            Rules : {
                from_id: [
                    { required: true, type: 'number',  message: '请选择A销售员', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                to_id: [
                    { required: true, type: 'number',  message: '请选择B销售员', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                customer_id: [
                    { required: true, type: 'array', min:1,  message: '至少选择一个客户', trigger: 'blur' }
                ]
            },
            columns: [
                {
                    type: 'selection',
                    width: 60,
                    fixed : 'left',
                    align: 'center'
                },
                {
                    title: '公司名称',
                    key: 'company',
                },
                {
                    title: '联系人',
                    key: 'name',
                    width : 140
                },
                {
                    title: '联系方式',
                    key: 'mobile',
                    width : 130
                }

            ],
        }
    },
    methods: {
        /**
         功能：
         time: 2025/12/16 11:12
         **/
        tableCheckAll(){
            let that = this;
            that.Forms.customer_id = [];
            const data = that.$refs.selection.getSelection();
            for(var i  = 0; i < data.length; i++ ){
                that.Forms.customer_id.push(data[i].id);
            }
        },
        /**
         功能：
         time: 2025/12/16 11:12
         **/
        getConfig(){
            let that = this;
            getCustomerConfig().then(e=>{
                that.salerList = e.data.salerList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/16 11:08
         **/
        getCustomerList(saler_id){
            let that = this;
            if(saler_id){
                that.Forms.customer_id = [];
                that.$store.commit('SET_LOADING' , true);
                getCustomerSelectList(saler_id).then(e => {
                    that.customerList = e.data ? e.data : [];
                })
            }
        },
        /**
         功能：
         time: 2025/12/16 11:12
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveCustomerTransfer(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/16 11:13
         **/
        show(){
            this.isBox = true;
            this.getConfig();
        },
        /**
         功能：
         time: 2025/12/16 11:15
         **/
        FormReset(){
            this.isBox = false;
            this.salerList = [];
            this.customerList = [];
            this.$refs['Forms'].resetFields();
            this.Forms.customer_id = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
